// extracted by mini-css-extract-plugin
export default {"hover":"category_hover__xEXei","frame":"category_frame__UAl+7"};